import { render, staticRenderFns } from "./ProjectWorkItemList.vue?vue&type=template&id=3f8da6ce&scoped=true"
import script from "./ProjectWorkItemList.vue?vue&type=script&lang=js"
export * from "./ProjectWorkItemList.vue?vue&type=script&lang=js"
import style0 from "./ProjectWorkItemList.vue?vue&type=style&index=0&id=3f8da6ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8da6ce",
  null
  
)

export default component.exports